import React, { useCallback } from 'react';

import { Status, Stack } from '@gogame/components';

import { MetricStatusActions } from 'scenes/Trackers/components/MetricStatus';

import {
  ACTIVE,
  PAUSED,
  DELETED,
  INACTIVE,
  CAMPAIGN_PAUSED,
  SET_PAUSED,
} from './constants';

export const getColor = (id) => {
  switch (id) {
    case ACTIVE:
      return 'success';
    case DELETED:
    case INACTIVE:
      return 'inactive';
    case PAUSED:
    case CAMPAIGN_PAUSED:
    case SET_PAUSED:
      return 'pending';
  }
};

const CreativeStatus = ({
  colDef: { editableCell: editable, onEditCell, field },
  row,
  onStart,
  onStop,
  ...props
}) => {
  const canPlay =
    props?.value?.statusId === PAUSED ||
    props?.value?.statusId === CAMPAIGN_PAUSED;
  const canPause = props?.value?.statusId === ACTIVE;
  const canDelete =
    props?.value?.statusId === ACTIVE ||
    props?.value?.statusId === PAUSED ||
    props?.value?.statusId === CAMPAIGN_PAUSED;

  const executeChangeStatus = useCallback(
    (status) => {
      onStart();
      onEditCell({
        status: props?.value?.statusId,
        col: field,
        rowData: row,
        value: status,
        onStop,
      });
    },
    [onEditCell]
  );

  const handlePlay = useCallback(() => {
    executeChangeStatus(ACTIVE);
  }, [executeChangeStatus]);

  const handlePause = useCallback(() => {
    executeChangeStatus(PAUSED);
  }, [executeChangeStatus]);

  const handleDelete = useCallback(() => {
    executeChangeStatus(DELETED);
  }, [executeChangeStatus]);

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      style={{ width: '100%', height: '100%' }}
    >
      <Status color={getColor(props?.value?.statusId)}>
        {props?.value?.value}
      </Status>
      {editable && (canPlay || canPlay || canDelete) ? (
        <MetricStatusActions
          onPlay={handlePlay}
          onPause={handlePause}
          onDelete={handleDelete}
          canPlay={canPlay}
          canPause={canPause}
          canDelete={canDelete}
        />
      ) : null}
    </Stack>
  );
};

export default CreativeStatus;
